const colores = {
	mainStrong: '#5A1372',
	mainPurple: '#33035f',
	mainPurpleTr: 'rgba(51, 3, 95,.8)',
	mainStrongTr: 'rgba(90, 19, 114,.8)',
	mainSoft: '#9280AB',
	mainSoftTr: 'rgba(146, 128, 171,.9)',
	mainSoftTr2: 'rgba(126, 109, 148,.6)',
	mainPink: '#FA405C',
	mainOrange: '#f0533d',
	mainOrangeTr: 'rgba(240, 83, 61,.9)',
	mainBlue: '#006ba2',
	mainBlueTr: 'rgba(0, 107, 162,.4)',
	secondary: '#B6A9CB',
	backgSoft: '#F2F5F8',
	backgStr: '#f0f0f0',
	txtLight: '#dedede',
	secondPink: 'rgb(156, 39, 176)',
	letterSecond: 'rgb(99, 99, 99)',
	textSoft: '#6b6c6d',
	dotsStep: '#784af4',
	txtSecond: '#3e3d3f',
	txtSecond2: '#4f4d52',
	//--------------------------
};

export default colores;
